var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"message",class:{success: _vm.message.success, fail: !_vm.message.success}},[_vm._v(_vm._s(_vm.message.msg))])])}
var staticRenderFns = []

export { render, staticRenderFns }